export const SCRIPT_SRC = process.env.NEXT_PUBLIC_ZENDESK_SCRIPT_SRC;

export const getDefaultSettings = () => {
  return "window.zESettings = { webWidget: { chat: { connectOnPageLoad: false }}};";
};
export const ZENDESK_CHAT_WIDGET_SELECTOR = "iframe[title*=messaging]";

export const ZENDESK_DEFAULT_ZINDEX = 99999;

export const ZENDESK_ZINDEX_VALUE_FOR_HIDING = -100;

export const ZENDESK_POSITION_BOTTOM_DEFAULT = "16px";
